import PaletteFacets from '../search/PaletteFacets'

const stringFacet = (key, label, options) => ({
  key,
  label,
  kind: 'multiselect',
  options,
  placeholder: 'Any',
  getOptionValue: (value) => value,
  getOptionLabel: (value) => value,
})

// Occupation, company, and school. The Filter header, search, and scope sit above.
function NetworkFilterPanel({ facets, values, onChange }) {
  const rows = [
    stringFacet('occupation', 'Occupation', facets.occupations || []),
    stringFacet('company', 'Company', facets.companies || []),
    stringFacet('school', 'School', facets.schools || []),
  ]

  return (
    <div className="nav-filter-panel" role="group" aria-label="Filter people">
      <div className="nav-filter-body">
        <PaletteFacets facets={rows} values={values} onChange={onChange} />
      </div>
    </div>
  )
}

export default NetworkFilterPanel
